import React, { useState } from 'react';
import { NameWrapper, TopInfoWrapper } from '../../../../CCHours.styled';
import AddDocument from './components/addDocument/AddDocument';
import Icon from '@/common/components/Icon';

const TopInfo = ({
	consultants,
	showConsultantMonth,
	selectedMonth,
	hanldeSearch,
}) => {
	const [isAddDocumentOpen, setIsAddDocumentOpen] = useState();

	return (
		<TopInfoWrapper>
			<NameWrapper>
				{selectedMonth?.label}:
				<b>
					<u>
						{
							consultants.find((c) => c.value === showConsultantMonth._id)
								?.label
						}
					</u>
				</b>
			</NameWrapper>
			<Icon
				onClick={() => setIsAddDocumentOpen(true)}
				className='animation-scale'
				name={'file-circle-plus'} color={'green'}
			/>
			{isAddDocumentOpen && (
				<AddDocument
					setIsAddDocumentOpen={setIsAddDocumentOpen}
					hanldeSearch={hanldeSearch}
					showConsultantMonth={showConsultantMonth}
				/>
			)}
		</TopInfoWrapper>
	);
};

export default TopInfo;
